import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';
import { ApiError, STATE_KEY, api } from '../api';

export function Login() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  return (
    <div className="center">
      <div className="login">
        <h1 className="login__title">
          MONSTERS
        </h1>
        <p className="card__text">Je collectie, je zoeklijst en je scanner.</p>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            setBusy(true);
            setError(null);
            try {
              await api('/api/auth/login', { method: 'POST', json: { password } });
              await qc.invalidateQueries({ queryKey: STATE_KEY });
              navigate('/', { replace: true });
            } catch (err) {
              setError(err instanceof ApiError ? err.message : 'Inloggen lukte niet.');
            } finally {
              setBusy(false);
            }
          }}
        >
          {/* Lets password managers file the entry under one account. */}
          <input type="text" name="username" autoComplete="username" value="monsters" readOnly hidden />
          <label className="field">
            <span className="field__label">Wachtwoord</span>
            <input
              className="input"
              name="password"
              type="password"
              autoComplete="current-password"
              autoFocus
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          {error && (
            <div className="error" role="alert">
              {error}
            </div>
          )}
          <button type="submit" className="btn" disabled={busy || !password}>
            Inloggen
          </button>
        </form>
      </div>
    </div>
  );
}
